<template>
  <div>
    <v-dialog v-model="showAlert" persistent max-width="450">
      <v-card>
        <v-card-title class="text-h5"> </v-card-title>
        <v-card-text>
          <span> {{ alertText || "Пожалуйста, дополните данные вашего профиля" }} </span>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="green darken-1"
            text
            @click="
              showAlert = false;
              showChangeProfileDialog = true;
            "
            >Хорошо</v-btn
          >
          <v-btn v-if="false" :disabled="!!interval" color="green darken-1" text @click="close()"> {{ interval ? interval : "Закрыть" }} </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <change-profile v-if="showChangeProfileDialog" v-model="showChangeProfileDialog" />
  </div>
</template>

<script>
import { genModel, validate, fillForm } from "@/components/mixings";
export default {
  mixins: [genModel, validate, fillForm],
  data() {
    return {
      showAlert: false,
      checkInterval: null,
      timer: null,
      interval: 0,
      model: [],
      alertText: "",
      showChangeProfileDialog: false,
    };
  },
  created() {
    this.checkInterval = setInterval(async () => {
      this.check();
    }, 15 * 60 * 1000);
    this.check();
  },
  computed: {},
  methods: {
    delay(n) {
      this.interval = n;
      this.timer = setInterval(() => {
        if (this.interval) {
          this.interval--;
        } else clearTimeout(this.timer);
      }, 1000);
    },
    close() {
      this.showAlert = false;
    },
    async check() {
      const m_profile = this.$store.getters["config/get"].models.profile;
      if (this.showAlert) return;
      if (!this.$root.profile?.id) return;
      if (m_profile?.checkRule?.data) {
        const m = this.initModel(m_profile, { values: this.$root.profile });
        const data = eval(m.checkRule.data?.formula)(this.$root.profile);
        const watch = m?.config?.watch;
        const model = await this.getModel(data?.[watch] || "default", m);
        if (await this.validateData(data, model, !true)) {
        } else {
          this.showAlert = true;
          if (this.checkInterval) clearInterval(this.checkInterval);
        }
      }
      if (this.$root.profile?.role == 10) {
        //let d = await this.$axios.post("/report_sql", { name: "getAlertTask", params: { user_id: this.$root.profile.id } });
        console.log("check profile");
        const m = m_profile;
        this.alertText = m.alertText;
        const watch = m?.config?.watch;
        const data = this.$root.profile.clients[0];
        const model = await this.getModel(data?.[watch] || "default", m);
        if (await this.validateData(data, model, !true)) {
        } else {
          this.showAlert = true;
          if (this.checkInterval) clearInterval(this.checkInterval);
        }
      }
    },
    fillForm() {},
    getModel(t, m) {
      let config;

      if (m.config?.configField && m.config?.config && Array.isArray(m.config.config)) {
        config = m.config.config.find(el => {
          if (Array.isArray(el.value)) return el.value.includes(this.data[m.config.configField]);
          return el.value == this.data[m.config.configField];
        });
      } else if (t || t === 0) config = JSON.parse(JSON.stringify(m?.config?.[t]));
      if (!config) config = m.config.default;
      let model = this.calcModelConfig(config, m);

      this.model = model;
      this.fillFormValidators(model);
      return model;
    },
  },
};
</script>
